import { Center, Spinner } from "@chakra-ui/react";
import {
  BuyerBidDetailDto,
  useGetBuyerSeQuestionsQuery,
  useGetSourcingEventQuery,
} from "../../../autogen/bff-api";
import { ClarificationsPanel } from "../communication/ClarificationsPanel";

export const ClarificationTab = ({ detail }: { detail: BuyerBidDetailDto }) => {
  const eventId = detail.bid.forEvent;
  const { data: event, isLoading: eventLoading } = useGetSourcingEventQuery({ eventId });
  const { data: questionsData, isLoading: questionsLoading } = useGetBuyerSeQuestionsQuery({ eventId });

  if (eventLoading || questionsLoading || !event) {
    return (
      <Center py="10">
        <Spinner color="smPrimary" />
      </Center>
    );
  }

  return (
    <ClarificationsPanel
      event={event}
      questions={questionsData?.questions ?? []}
      supplierOrganizationId={detail.ownerOrganizationId}
    />
  );
};
